import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react"


const cryptoAPiHeaders = {
    'X-RapidAPI-Host': 'coinranking1.p.rapidapi.com',
    'X-RapidAPI-Key': '6b49313f0bmsha56947600c406c9p1d41c8jsnefc9c1462047'
}

const baseUrl = 'https://coinranking1.p.rapidapi.com';

const createRequest = (url) =>({ url, headers: cryptoAPiHeaders})


export const cryptoApi = createApi({
    reducerPath: 'createApi',
    baseQuery: fetchBaseQuery({ baseUrl}),
    endpoints: (builder) =>({
        getCryptos :  builder.query({
            query : (count) => createRequest(`/coins?limit=${count}`)
        }),
        getCryptosDetails : builder.query({
            query : (coinId) => createRequest(`/coin/${coinId}`)
        }),
        getCryptosHistory : builder.query({
            query : ({coinId, timePeriod}) => createRequest(`/coin/${coinId}/history?timePeriod=${timePeriod}`)
        }),
       
    })
}) 

export const {
    useGetCryptosQuery, useGetCryptosDetailsQuery, useGetCryptosHistoryQuery
} = cryptoApi;